import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStoresDetails } from "./StoreSlice";
import images from "../../assets/images/constantImages";
import { Link } from "react-router-dom";
import { PacmanLoader } from "react-spinners";

const UserStoreSelect = () => {
  const [selectedStore, setSelectedStore] = useState(null);

  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.store);

  useEffect(() => {
    dispatch(getStoresDetails());
  }, [dispatch]);

  const handleSelect = (storeId) => {
    setSelectedStore(storeId);
    localStorage.setItem("selectedStoreId", storeId);
  };

  if (loading) return (
    <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
      <PacmanLoader color="#85bd3a" size={40} />
    </div>
  );
  return (
    <div className="bg-gradient-to-b from-white to-[#ebf5e6]">
      <div
        className="relative h-screen w-full bg-center bg-cover flex flex-col items-center justify-center"
        style={{ height: "100vh", objectFit: "conatin", backgroundImage: `url(${images.BGimage})` }}
      >
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-10 text-center z-10">
          Select Your Game Zone
        </h1>
        <div className="max-h-[70vh] overflow-y-auto scroll-smooth">

          {loading ? (
            <p className="text-center text-lg z-10">Loading stores...</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 z-10 place-items-center">
              {data
                ?.filter((store) => store.canteen_user && store.canteen_user !== "null")
                ?.map((store) => (
                  <>
                    <Link
                      to={`/scanner/${store.vendor_id}`}
                      key={store.vendor_id}
                      onClick={() => handleSelect(store.vendor_id)}
                      className="flex flex-col items-center"
                    >
                      <div className="w-26 h-26 md:w-32 md:h-32 rounded-full border-[6px] border-white shadow-lg flex justify-center items-center p-2">
                        <img
                          src={store.store_logo || images.Gpay}
                          alt={store.store_name}
                          loading="lazy"
                          className="w-24 h-24 md:w-28 md:h-28 rounded-full object-cover"
                        />
                      </div>
                      <div className="mt-3 bg-[#85BD3A] inline-block text-white font-medium text-sm md:text-base rounded-md px-4 py-1 shadow">
                        {store.store_name}
                      </div>
                    </Link>
                  </>
                ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserStoreSelect;
